module.exports = __webpack_public_path__ + "static/img/map6.c6c5af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map6.png
// module id = zIO9
// module chunks = 0